import {
  PerformApplicationActionMutationCgResponse,
  PerformApplicationActionMutationVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const PERFORM_APPLICATION_ACTION: TypedDocumentNode<
  PerformApplicationActionMutationCgResponse,
  PerformApplicationActionMutationVariables
> = gql`
  mutation PerformApplicationAction(
    $staffingRequestApplicationId: ID!
    $input: PerformApplicationActionInput!
  ) {
    performApplicationAction(
      staffingRequestApplicationId: $staffingRequestApplicationId
      input: $input
    ) {
      staffingRequestApplication {
        id
        state
        stateChangedAt
        rejectionReason
        rejectionReasonDescription
        rejectionDetails
        staffingRequest {
          id
          submittedStaffingRequestApplicationsCount
          inReviewStaffingRequestApplicationsCount
          offeredOffersStaffingRequestApplicationsCount
          acceptedStaffingRequestApplicationsCount
          withdrawnStaffingRequestApplicationsCount
          rejectedStaffingRequestApplicationsCount
        }
        activeOffer {
          id
          state
          stateChangedAt
        }
      }
      error
    }
  }
`;

export const ResubmitApplication = gql`
  mutation ResubmitApplication(
    $staffingRequestApplicationId: ID!
    $worksSubmittalPacketId: ID!
    $input: ResubmitApplicationInput!
  ) {
    resubmitApplication(
      staffingRequestApplicationId: $staffingRequestApplicationId
      worksSubmittalPacketId: $worksSubmittalPacketId
      input: $input
    ) {
      staffingRequestApplication {
        id
        state
        stateChangedAt

        worksProfile {
          id
          fullName
          activeSubmissionsCount
        }

        activeOffer {
          id
          state
          stateChangedAt
        }
        canWithdraw {
          value
        }
        canResubmit {
          value
        }
      }
    }
  }
`;

export const CreateStaffingRequestApplicationMutation = gql`
  mutation CreateStaffingRequestApplicationMutation(
    $worksProfileId: ID!
    $staffingRequestId: ID!
    $worksSubmittalPacketId: ID!
    $input: CreateStaffingRequestApplicationInput!
  ) {
    createStaffingRequestApplication(
      worksProfileId: $worksProfileId
      staffingRequestId: $staffingRequestId
      worksSubmittalPacketId: $worksSubmittalPacketId
      input: $input
    ) {
      staffingRequestApplication {
        id
        worksProfile {
          id
          firstName
          lastName
          fullName
        }
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const CreateWorksProfileIdentificationCode = gql`
  mutation createWorksProfileIdentificationCode(
    $worksProfileId: ID!
    $lastFourSsn: String!
    $staffingRequestId: ID!
  ) {
    createWorksProfileIdentificationCode(
      worksProfileId: $worksProfileId
      lastFourSsn: $lastFourSsn
      staffingRequestId: $staffingRequestId
    ) {
      worksProfile {
        id
        identificationCode
      }
      doNotRehire
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;
